module.exports = __webpack_public_path__ + "img/document_with_calculator.2beccb6b.svg";